export const  POST_COUPON_VERIFY_SUCCESS='couponVerifyReducer/POST_COUPON_VERIFY_SUCCESS';
export const  POST_COUPON_VERIFY_REQUEST='couponVerifyReducer/POST_COUPON_VERIFY_REQUEST';
export const  POST_COUPON_VERIFY_FAILED='couponVerifyReducer/POST_COUPON_VERIFY_FAILED';